import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/okapi-banner.svg'


const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center chat-content coming-soon-container" }
const _hoisted_2 = ["href"]

import { TALK_TO_THE_BOOKS_FEEDBACK_FORM } from '@/assets/strings';

export default /*@__PURE__*/_defineComponent({
  __name: 'ComingSoonMessage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      class: "img-fluid",
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", null, [
      _createTextVNode("體驗探索書的全新方式"),
      _createElementVNode("br"),
      _createTextVNode(" ~ Coming soon ~ ")
    ], -1)),
    _createElementVNode("a", {
      type: "button",
      class: "btn feedback-button",
      href: _unref(TALK_TO_THE_BOOKS_FEEDBACK_FORM),
      target: "_blank"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("div", null, [
        _createElementVNode("svg", {
          width: "18",
          height: "18",
          viewBox: "0 0 19 18",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M18.43 5.45C18.43 5.06 18.28 4.69 18 4.41L14.01 0.42C13.73 0.15 13.37 0 12.98 0C12.59 0 12.22 0.15 11.95 0.43L0.93 11.44C0.65 11.72 0.5 12.08 0.5 12.48V16.47C0.5 17.28 1.16 17.93 1.96 17.93H5.95C6.34 17.93 6.71 17.78 6.98 17.5L15.34 9.14C15.34 9.14 15.34 9.14 15.35 9.14C15.36 9.14 15.35 9.14 15.35 9.13L17.99 6.49C18.28 6.21 18.43 5.84 18.43 5.45ZM5.94 16.43L2 16.47L1.99 12.5L9.8 4.65L13.76 8.61L5.94 16.43ZM14.82 7.55L10.86 3.59L12.95 1.49L16.94 5.43L14.82 7.55Z",
            transform: "translate(0 -3)",
            fill: "#FFFFFF"
          })
        ]),
        _createElementVNode("div", null, " 體驗回饋 ")
      ], -1)
    ]), 8, _hoisted_2)
  ]))
}
}

})